<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    v-bind="$attrs"
  >
    <path
      d="M3.14867 3.047C2.9978 3.34774 2.9236 3.71874 2.7752 4.46074L2.27693 6.95208C1.96144 8.52955 3.16799 10.0013 4.7767 10.0013C6.08639 10.0013 7.183 9.00888 7.31332 7.70569L7.37083 7.13059C7.23492 8.67113 8.44916 10.0013 10.0002 10.0013C11.5618 10.0013 12.7821 8.65297 12.6267 7.09911L12.6875 7.70569C12.8178 9.00888 13.9144 10.0013 15.2242 10.0013C16.8328 10.0013 18.0394 8.52955 17.7239 6.95208L17.2257 4.46074C17.0772 3.71876 17.003 3.34774 16.8522 3.047C16.5342 2.41329 15.9622 1.94437 15.2785 1.75693C14.954 1.66797 14.5757 1.66797 13.819 1.66797H12.0836H6.18183C5.42515 1.66797 5.0468 1.66797 4.72231 1.75693C4.03857 1.94437 3.46656 2.41329 3.14867 3.047Z"
      fill="currentColor"
    />
    <path
      d="M15.2251 11.2501C15.906 11.2501 16.5386 11.0731 17.0846 10.7659V11.6668C17.0846 14.8095 17.0846 16.3808 16.1083 17.3571C15.3224 18.1431 14.151 18.2963 12.0846 18.3262V15.4168C12.0846 14.638 12.0846 14.2486 11.9171 13.9585C11.8075 13.7685 11.6496 13.6106 11.4596 13.501C11.1696 13.3335 10.7801 13.3335 10.0013 13.3335C9.22247 13.3335 8.83305 13.3335 8.54297 13.501C8.35297 13.6106 8.19514 13.7685 8.08544 13.9585C7.91797 14.2486 7.91797 14.638 7.91797 15.4168V18.3262C5.85166 18.2963 4.68019 18.1431 3.89428 17.3571C2.91797 16.3808 2.91797 14.8095 2.91797 11.6668V10.7659C3.464 11.0731 4.09663 11.2501 4.77761 11.2501C5.77517 11.2501 6.68978 10.8638 7.37159 10.2267C8.06104 10.8602 8.98172 11.2501 10.0011 11.2501C11.0206 11.2501 11.9414 10.8601 12.6309 10.2266C13.3127 10.8637 14.2274 11.2501 15.2251 11.2501Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: 'TaxOfficesIcon',
  inheritAttrs: false,
  props: {
    size: {
      type: [Number, String],
      default: 20
    }
  }
}
</script>